import { useEffect, useState } from "react";
import { MdPersonAddAlt1 } from "react-icons/md";
import AddButton from "../../components/buttons/AddButton";
import Dashboard from "../../components/Dashboard";
import Table, { Badge } from "../../components/Table";
import PhysicianForm from "../../components/forms/PhysicianForm";
import {
  physicianTableHeadData,
  // getPhysicianTableData,
} from "../../constants/data/physiciansData";
import { useForm } from "../../context/formContext";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { useSelector } from "react-redux";
import { Spinner } from "@material-tailwind/react";
import { useModal } from "../../context/modalContext";
import Physician from "../../components/Modals/Physician";
// import Delete from "../../components/buttons/DeleteButton";
import Edit from "../../components/buttons/Edit";
import Delete from "./../../components/buttons/DeleteButton";
import DeleteUserModal from "../../components/Modals/DeleteUserModal";

const PhysiciansPage = () => {
  const { showForm, openForm, closeForm } = useForm();
  const [showSpin, setShowSpin] = useState(false);
  const { token } = useSelector((state) => state.user);
  const [physicianTableData, setPhysicianTableData] = useState([]);
  const {
    showEditModal,
    showModal,
    openModal,
    closeModal,
    closeEditModal,
    openDeleteModal,
    closeDeleteModal,
    showDeleteModal,
  } = useModal();
  useEffect(() => {
    const fetchData = async () => {
      setShowSpin(true);
      try {
        const { data } = await HttpClient.apiCaller(
          "admin/user-list?role=mro",
          "GET",
          null,
          token,
          null
        );
        // console.log(">>>>>>>>>>>", data.user);
        setPhysicianTableData(data?.user);
      } catch (error) {
        console.log(error);
      } finally {
        setShowSpin(false);
      }
    };

    fetchData();

    return () => {};
  }, [closeForm, closeEditModal]);
  const getPhysicianTableData = (dataSet) => {
    let tableData = dataSet?.map((item, idx) => {
      return {
        no: idx + 1,
        uid: item?.uid,
        firstName: item?.first_name || "N/A",
        lastName: item?.last_name || "N/A",
        email: item?.email || "N/A",
        mobile: item?.mobile_number,
        npiNumber: item?.npi,
        // status: <Badge status={item?.status} />,
        action: (
          <div className="flex gap-3">
            <Edit user={item} />
            <Delete user={item} />
          </div>
        ),
      };
    });
    return tableData;
  };
  return (
    <Dashboard>
      {showForm ? (
        <PhysicianForm onClose={closeForm} />
      ) : (
        <>
          <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
            <div>
              <p className="poppins-medium  leading-[21px]  text-gray-700 mb-2">
                List of Medical Review Officer
              </p>
              <p className="poppins-regular text-xs text-[#B5B5C3] ">
                {physicianTableData?.length} available physicians
              </p>
            </div>
            {/*  */}
            <AddButton
              onClick={openForm}
              buttonName={"Add New MRO"}
              icon={<MdPersonAddAlt1 className="size-5" />}
            />
          </div>
          {/*  table */}
          {showSpin ? (
            <div className="w-full mt-20 flex items-center justify-center">
              <Spinner className="h-12 w-12" />{" "}
            </div>
          ) : (
            <Table
              tableData={getPhysicianTableData(physicianTableData)}
              tableHeadData={physicianTableHeadData}
            />
          )}
        </>
      )}
      {/*Edit modal */}
      {showEditModal ? (
        <Physician edit={true} onClose={closeEditModal} />
      ) : (
        <></>
      )}
      {/* delete modal */}
      {showDeleteModal && <DeleteUserModal onClose={closeDeleteModal} />}
    </Dashboard>
  );
};

export default PhysiciansPage;
